export default "__VITE_ASSET__Ck7JKXCV__"